import { combineGuardsSerial } from '../../composer/combineGuardsSerial';
import { determineI18nResourceGuard } from '../../guards/determineI18nResourceGuard';
import { determineLanguageGuard } from '../../guards/determineLanguageGuard';
import { generateBaseTokenGuard } from '../../guards/generateBaseTokenGuard';
import { onboardingInitialGuard } from '../../guards/onboarding/onboardingInitialGuard';

import type { AnyOfGuard } from '../../../types';

/**
 * Onboarding 초기 진입 가드 체인 (전체 순차 실행)
 *
 * 1. onboardingInitialGuard — 확장 포인트
 * 2. generateBaseTokenGuard — KC_AUT 쿠키 기반 토큰 검증 + 사용자 정보
 * 3. determineLanguageGuard — IAM API 기반 언어 결정 (token/userId 의존 → 순차 필수)
 * 4. determineI18nResourceGuard — i18n 리소스 로드 (language 의존)
 */
const baseGuardArray = [
  onboardingInitialGuard,
  generateBaseTokenGuard,
  determineLanguageGuard,
  determineI18nResourceGuard,
];

export const generateInitialServerSideGuards = (additionalGuards?: AnyOfGuard[]) => {
  const additions = additionalGuards ?? [];

  return combineGuardsSerial([...baseGuardArray, ...additions]);
};
